import { DailyCash, DailyCashCreate } from "../Components/index.js";

export default [
    {
        path: "/voucher/fd/daily-cash",
        component: DailyCash,
        name: "voucher.fd.daily.cash",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/daily-cash/entry",
        component: DailyCashCreate,
        name: "voucher.fd.daily.cash.create",
        meta: {
            requiresAuth: true,
        },
    },
];
